import React, { useState } from "react";
import { Link } from "react-router-dom";
import { func } from "prop-types";
import {
  Grid,
  Hidden,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import DesktopHeader from "./DesktopHeader";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { useSelector } from "react-redux";
import brandTheme from "brandTheme/Theme";
import logo from "../../../assets/img/headerLogo.jpeg";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: brandTheme.headerBackGroundColor,
    width: "100%",
    height: "80px",
    padding: "0 56px",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]:{
      padding: "0px 16px",
    },
  },

  leftSection: {
    display: "flex",
    alignItems: "center",
    height:'100%',
  },
  logoContainer: {
      display:'flex',
      alignItems:'center',
      height:'100%',
      
      [theme.breakpoints.down("sm")]:
        {
          paddingTop:'15px',
        },
    },
  logo: {
    height: "60px",
    width: "auto",

    [theme.breakpoints.down("sm")]: {
      height: "66px",
    },
  },

  menuButton: {
    marginRight: theme.spacing(1),
    color: "#000",
  },

  rightSection: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
}));

const Header = ({ handleDrawerToggle, userDetailData }) => {
  const classes = useStyles();
  const { enabled } = useSelector((state) => state?.login?.adminPortalData) || false;

  const { authToken } = useSelector(
    (state) => state.login.authData
  );

const linkDestination = authToken
  ? enabled
    ? "/adminPortal"
    : "/dashboard"
  : "/welcome";
  const [callInProgress, setCallInProgress] = useState(false);

  return (
    <>
      <Grid container className={classes.container}>
        <Grid item xs={8} sm={6} className={classes.leftSection}>
          <Link to={linkDestination} className={classes.logoContainer}>
            <img
              src={logo}
              alt="Logo"
              className={classes.logo}
            />
          </Link>
        </Grid>
        <Grid item xs={4} sm={6} className={classes.rightSection}>
          <Hidden smDown>
            <DesktopHeader
              userDetailData={userDetailData}
            />
          </Hidden>
          <Hidden mdUp>
            <DesktopHeader
              userDetailData={userDetailData}
              mobileView={true}
            />
          </Hidden>
          <Hidden mdUp>
            <IconButton
              edge="start"
              className={classes.menuButton}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          </Hidden>
        </Grid>
      </Grid>
      {callInProgress && (
        <CircularProgresss
          callInProgress={callInProgress}
        />
      )}
    </>
  );
};

Header.propTypes = {
  handleDrawerToggle: func.isRequired,
};

export default Header;